export default "__VITE_ASSET__bb1dc96b__"